<script lang="ts" setup>
import { computed } from 'vue';

const { label, error = '', withFocus = true } = defineProps<{ label?: string; error?: string; withFocus?: boolean }>();
const hasError = computed(() => error && error.length > 0);
</script>

<template>
  <div class="base-field" :class="{ hasError, focus: withFocus }">
    <slot></slot>
    <label class="label"> {{ label }} </label>
    <div class="notes">
      <span v-if="hasError" class="error">
        {{ error }}
      </span>
      <span v-else>
        <slot name="note" />
      </span>
      <slot name="note-append" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
$error-color: $ui-error;
.base-field {
  display: flex;
  align-items: center;

  justify-content: space-between;

  position: relative;
  border: 1px solid $ui-outline-default;
  border-radius: $border-radius;
  height: 24px;
  padding: $items-spacing;

  transition: border-color 0.3s ease;

  .label {
    position: absolute;
    left: 10px;
    top: -9px;
    transition: transform 0.3s ease;
    background-color: $ui-white;
    padding: 0 4px;
    font-size: $typography-label-size;
  }
}
.focus {
  &:focus-within {
    border: 2px solid $ui-outline-focus;
    height: 22px;
  }
}
.hasError {
  border: 2px solid $error-color;
  height: 22px;
  color: $error-color;
  ::placeholder {
    color: $error-color;
  }

  :deep {
    label,
    // div,
    input {
      color: $error-color;
    }
  }
  &:focus-within {
    border: 2px solid $error-color;
    height: 22px;
  }
}
.label {
  position: absolute;
  left: 10px;
  top: -9px;
  transition: transform 0.3s ease;
  background-color: $ui-white;
  padding: 0 4px;
  color: $typography-secondary-color;
  font-size: $typography-label-size;
}

.notes {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: calc(100% - 20px);
  top: 60px;
  left: 0;
  transition: transform 0.3s ease;
  background-color: $ui-white;
  padding: 0 10px;
  color: $typography-secondary-color;
  font-size: $typography-label-size;
  text-align: left;
  background: transparent;

  .error {
    color: $error-color;
  }
}
</style>
